import React, { memo } from "react";
import { Icon, IconProps } from "@chakra-ui/icon";

const PhoneSmsIcon = (props: IconProps) => (
  <Icon w="11px" h="14px" viewBox="0 0 11 14" {...props}>
    <path
      fillRule="evenodd"
      d="M1.4002 10.4002h6v-.60001h1.2v2.40001c0 .66-.54 1.2-1.2 1.2h-6c-.660005 0-1.200005-.54-1.200005-1.2v-10.8c0-.660005.54-1.200005 1.200005-1.200005h6c.66 0 1.2.54 1.2 1.200005v2.4h-1.2v-.6h-6v7.2Zm6-9h-6v.6h6v-.6Zm-6 10.8h6v-.6h-6v.6Zm2.7-4.8c.49705 0 .9-.40295.9-.9 0-.49706-.40295-.90001-.9-.90001-.49706 0-.9.40295-.9.90001 0 .49705.40294.9.9.9Zm3.9-.9c0 .49705-.40295.9-.9.9-.49706 0-.9-.40295-.9-.9 0-.49706.40294-.90001.9-.90001.49705 0 .9.40295.9.90001Zm2.1.9c.4971 0 .9-.40295.9-.9 0-.49706-.4029-.90001-.9-.90001-.49706 0-.9.40295-.9.90001 0 .49705.40294.9.9.9Z"
      clipRule="evenodd"
    />
  </Icon>
);

export default memo(PhoneSmsIcon);
